import React from 'react';
import { css } from '@linaria/core';
import { DownloadImageButton } from 'components/DownloadImageButton/DownloadImageButton';
interface ImageOutputViewProps {
  data: CF.API.BaseImageData;
}
export const ImageOutputView: React.FC<ImageOutputViewProps> = ({
  data
}) => {
  const imageOutput = ({
    data
  } as CF.API.Inputs.Input);
  return <div className={imageOutputViewStyles}>
      <p className={imageOutputViewHeader}>Image Output:</p>
      <div className={imageOutputViewDetails}>
        <span>height: {data?.image?.image_info?.height}px</span>
        <span>width:⠀ {data?.image?.image_info?.width}px</span>
      </div>
      <img className={imageOutputViewImage} alt="model output" src={`data:image/png;base64,${data?.image?.base64}`} />
      <DownloadImageButton input={imageOutput} useBase64 />
    </div>;
};
const imageOutputViewStyles = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__ImageOutputView_tsx-imageOutputViewStyles-i1lt857y";
const imageOutputViewHeader = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__ImageOutputView_tsx-imageOutputViewHeader-i1dbljj9";
const imageOutputViewDetails = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__ImageOutputView_tsx-imageOutputViewDetails-i16htf76";
const imageOutputViewImage = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__ImageOutputView_tsx-imageOutputViewImage-i1x2m9yo";

require("./ImageOutputView.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ImageOutputView.tsx");